import React from 'react'
import agent from '../agent'
import ChatPostList from './widgets/ChatPostList'
import Loading from './widgets/Loading'
import { connect } from 'react-redux'
import Pager from 'react-pager'
import { DatePicker } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import { Link } from 'react-router-dom'
import {
    CHANNEL_DETAIL_PAGE_LOADED,
    CHANNEL_DETAIL_PAGE_UNLOADED,
    CHANNEL_DETAIL_NEXT_PAGE_LOADED,
    CHANNEL_DETAIL_SEARCH_LOADED,
    UPDATE_FIELD_CHANNEL_DETAIL_SEARCHTERM,
    CHANGE_DATE_STRINGS
} from '../constants/actionTypes'
import { store } from '../store'
import { push } from 'react-router-redux'

const Promise = global.Promise;
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY/MM/DD';

const mapStateToProps = state => ({
    ...state.chat,
    currentUser: state.common.currentUser,
    date_from: state.common.date_from,
    date_to: state.common.date_to
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload, pageIndex, terms, date_from, date_to) =>
        dispatch({ type: CHANNEL_DETAIL_PAGE_LOADED, payload, currentPage: pageIndex, searchTerm: terms, date_from, date_to }),
    onLoadNextPage: (payload, pageIndex, terms, date_from, date_to) => {
        dispatch({ type: CHANNEL_DETAIL_NEXT_PAGE_LOADED, payload, currentPage: pageIndex, searchTerm: terms, date_from, date_to })
    },
    onSearch: (payload, pageIndex, terms, date_from, date_to) => {
        dispatch({ type: CHANNEL_DETAIL_SEARCH_LOADED, payload, currentPage: pageIndex, searchTerm: terms, date_from, date_to })
    },
    onChangeSearchTerm: value =>
        dispatch({ type: UPDATE_FIELD_CHANNEL_DETAIL_SEARCHTERM, key: 'searchTerm', value }),
    onChangeDateStrings: (date_from, date_to) =>
        dispatch({ type: CHANGE_DATE_STRINGS, date_from, date_to }),
    onUnload: () =>
        dispatch({ type: CHANNEL_DETAIL_PAGE_UNLOADED }),
});

class ChannelDetail extends React.Component {
    constructor() {
        super()
        this.changeSearchTerm = (ev) => this.props.onChangeSearchTerm(ev.target.value)
        this.search = () => ev => {
            ev.preventDefault()
            const pageIndex = 1;
            const terms = this.props.searchTerm || ''
            const date_from = this.props.date_from || ''
            const date_to = this.props.date_to || ''
            const payload = agent.Chats.chatDetail(this.props.match.params.key, pageIndex, terms, date_from, date_to)
            this.props.onSearch(payload, pageIndex, terms, date_from, date_to)
        }
    }

    componentWillMount() {
        const pageIndex = 1;
        const terms = ''
        const date_from = ''
        const date_to = ''
        this.props.onLoad(agent.Chats.chatDetail(this.props.match.params.key, pageIndex, terms, date_from, date_to), pageIndex, terms, date_from, date_to);
    }

    componentWillUnmount() {
        this.props.onUnload();
    }
    handlePageChanged(newPage) {
        const pageIndex = newPage + 1;
        const terms = this.props.searchTerm || ''
        const date_from = this.props.date_from || ''
        const date_to = this.props.date_to || ''
        this.props.onLoadNextPage(agent.Chats.chatDetail(this.props.match.params.key, pageIndex, terms, date_from, date_to), pageIndex, terms, date_from, date_to);
    }
    handleChangeDateStrings(dates, dateStrings) {
        var unixFrom = dateStrings[0] ? moment(dateStrings[0]).format('X') : ''
        var unixTo = dateStrings[1] ? moment(moment(dateStrings[1]).format('YYYY-MM-DD 23:59:59')).format('X') : ''
        this.props.onChangeDateStrings(unixFrom, unixTo)
    }
    render() {
        if (!this.props.channel) {
            return (
                <Loading />
            )
        }
        const date_from = this.props.date_from ? moment(moment(this.props.date_from * 1000).format('YYYY-MM-DD')) : ''
        const date_to = this.props.date_to ? moment(moment(this.props.date_to * 1000).format('YYYY-MM-DD')) : ''

        return (
            <div class='pane'>
                <Link className="crumb" to="/channels">&laquo; back to channels</Link>

                <h1>Channel Detail</h1>
                <div className="infoGroup">
                    <div className="infoPair">
                        <label>Key:</label> <span><Link to={`/channels/${this.props.channel.key}/edit`}>{this.props.channel.key}</Link></span>
                    </div>
                    <div className="infoPair">
                        <label>Title:</label> <span>{this.props.channel.title}</span>
                    </div>
                    <div className="infoPair">
                        <label>Language:</label> <span>{this.props.channel.language}</span>
                    </div>
                </div>

                <div className="infoGroup">
                    <div className="infoAction">
                        <h2>Post List</h2>
                        <div className="filters">
                            <div className="filterSearch">
                                <RangePicker
                                    ranges={{ 'This Month': [moment().startOf('month'), moment()], Today: [moment(), moment()] }}
                                    value={[date_from, date_to]}
                                    onChange={this.handleChangeDateStrings.bind(this)}
                                />
                                <input type="text" placeholder="find by key" value={this.props.searchTerm} onChange={this.changeSearchTerm} />
                                <button type="submit" onClick={this.search()}>Find</button>
                            </div>
                        </div>
                        <ChatPostList channelkey={this.props.channel.key} posts={this.props.posts} loading={this.props.loading} />
                        {
                            this.props.posts && this.props.posts.length > 0 ?
                                <Pager
                                    total={this.props.totalPage || 0}
                                    current={this.props.currentPage - 1}
                                    visiblePages={7}
                                    titles={{ first: '<<', last: '>>' }}
                                    onPageChanged={this.handlePageChanged.bind(this)}
                                />
                                : null
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChannelDetail);



// WEBPACK FOOTER //
// ./src/components/ChannelDetail.js